import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { useI18n } from '../context/I18nContext';
import logo from '../assets/constellia.png';
import { AuthAlert } from '../components/AuthAlert';
import { getErrorMessage } from '../utils/errorUtils';
import './AuthPages.css';

const LoginPage = ({ onLoginSuccess }) => {
  const { t, language, setLanguage, availableLanguages } = useI18n();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleLanguageChange = (e) => {
    const chosenLang = e.target.value;
    setLanguage(chosenLang);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post('/auth/login', 
        { email, password },
        { withCredentials: true }
      );

      if (response.data.success) {
        onLoginSuccess();
        navigate('/dashboard');
      }
    } catch (err) {
      setError(getErrorMessage(err, t, 'auth'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <img src={logo} alt="Constellia Logo" className="auth-logo" />
          <h2>{t('auth.login')}</h2>
          <p>{t('app.subtitle')}</p>
        </div>

        {/* Quebec Law / Accessibility Compliant Language Selector */}
        <div className="language-selector-wrapper">
          <label htmlFor="register-language-select">
            🌐 {t('nav.language')}:
          </label>
          <select
            id="register-language-select"
            value={language}
            onChange={handleLanguageChange}
            className="language-select-input"
          >
            <option value="fr">Français</option>
            <option value="en">English</option>
            <option value="sw">Kiswahili</option>
          </select>
        </div>


        {/*{error && <div className="auth-error-alert">{error}</div>}*/}
        <AuthAlert error={error} />

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email" className="form-label">
              {t('auth.email')}
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="form-input"
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password" className="form-label">
              {t('auth.password')}
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="form-input"
              disabled={loading}
            />
            <p className="form-hint">
              {t('auth.noAccount')} <Link to="/register">{t('auth.register')}</Link>
            </p>
          </div>

          <button 
            type="submit" 
            className="auth-button"
            disabled={loading}
          >
            {loading ? t('common.loading') : t('auth.loginButton')}
          </button>
        </form>

        <div className="auth-demo">
          <p><strong>Demo Credentials:</strong></p>
          <p>Email: demo@example.com</p>
          <p>Password: demo123</p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;

